import React, { Children } from 'react';
import { motion } from 'framer-motion';
const features = ['Organize your entire wedding in one place', 'Track your budget clearly', 'Manage vendors professionally', 'Plan your guest list with intention', 'Build your timeline without confusion', 'Keep every detail aligned with your vision'];
export function SolutionSection() {
  return <section className="w-full bg-[#EEF3ED] py-24 px-6 md:py-32" data-id="element-184">
      <div className="max-w-6xl mx-auto" data-id="element-185">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-186">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-187">
            <span className="text-xs uppercase tracking-[0.2em] text-[#8FAF88] font-medium block mb-6" data-id="element-188">
              The Solution
            </span>
            <h2 className="text-4xl md:text-5xl font-light text-[#2C2C2C] mb-8 leading-tight" data-id="element-189">
              Meet Your Structured <br data-id="element-190" />
              <span className="italic" data-id="element-191">Planning System</span>
            </h2>
            <p className="text-lg text-[#2C2C2C] font-light leading-relaxed mb-8" data-id="element-192">
              The Complete Wedding Planner is a thoughtfully designed digital
              planner that helps you regain control and find joy in the process.
            </p>
            <div className="w-12 h-[1px] bg-[#C4A882] opacity-50" data-id="element-193"></div>
          </motion.div>

          {/* Right Column - Feature List */}
          <div className="relative" data-id="element-194">
            <motion.ul className="space-y-6" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={{
            visible: {
              transition: {
                staggerChildren: 0.1
              }
            }
          }} data-id="element-195">
              {features.map((feature, index) => <motion.li key={index} variants={{
              hidden: {
                opacity: 0,
                y: 10
              },
              visible: {
                opacity: 1,
                y: 0
              }
            }} className="flex items-start group" data-id="element-196">
                  <span className="inline-block w-2 h-2 rounded-full bg-[#8FAF88] mt-2 mr-4 opacity-70 group-hover:scale-125 transition-transform duration-300" data-id="element-197"></span>
                  <span className="text-lg text-[#2C2C2C] font-light" data-id="element-198">
                    {feature}
                  </span>
                </motion.li>)}
            </motion.ul>

            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.8,
            duration: 0.8
          }} className="mt-12 text-xl font-serif italic text-[#6B8F64]" data-id="element-199">
              No clutter. No overwhelming florals. Just clean structure and
              elegant sage minimalism.
            </motion.p>
          </div>
        </div>
      </div>
    </section>;
}